import React, { useState, useEffect } from "react";
import { Button, Table, Modal, Badge, Form, Input, Switch, message, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Get_Brands_By_Id,
  Add_Brand,
  Brand_Status,
  Update_Brand
} from "../../redux/Brands/BrandsActions";
import { CopyOutlined, EditOutlined } from '@ant-design/icons';
import { getAiKeywords, saveAiKeywords } from "../../redux/AiKeywords/AiKeywordsActions";

const Brands = () => {
  const userData = useSelector((state) => state.Auth.userData);
  const allData = useSelector((state) => state.Brands.data);
  const isLoading = useSelector((state) => state.Brands.isLoading);
  const isAddLoading = useSelector((state) => state.Brands.isAddLoading);
  const { isLoadingAiKeywords, isLoadingSaveAiKeywords, AiKeywordsdata } = useSelector((state) => state.AiKeywordsReducer);
  const usertoken = useSelector((state) => state.Auth.token);
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [Record, setRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [keywordToken, setKeywordToken] = useState(null);
  const [aiModal, setAiModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const data = {
      companyId: userData?.companyId,
      id: userData?._id
    };
    dispatch(Get_Brands_By_Id(data, usertoken));
  }, []);

  const showModal = (isEdited) => {
    if (!isEdited) {
      form.resetFields();
      setIsEdit(null);
    }
    setIsEdit(isEdited);
    setOpen(true);
  };

  const afterSuccess = () => {
    form.resetFields();
    setOpen(false);
  };

  const afterAdded = () => {
    const data = {
      companyId: userData?.companyId,
      id: userData?._id
    };
    dispatch(Get_Brands_By_Id(data, usertoken));
  };

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success('Copied!');
    } catch {
      message.error('Failed to copy!');
    }
  };

  const onFinish = (values) => {
    if (isEdit) {
      const data = {
        brandDomain: values.brandDomain,
        brandname: values.brandName,
        _id: Record?._id,
        admin_id: userData?._id,
        companyId: userData?.companyId
      };
      dispatch(Update_Brand(data, usertoken, afterSuccess, afterAdded));
    }
    else {
      const data = {
        brandDomain: values.brandDomain,
        brandname: values.brandName,
        admin_id: userData?._id,
        companyId: userData?.companyId
      };
      dispatch(Add_Brand(data, usertoken, afterSuccess, afterAdded));
    }
  };

  const onFinishAiKeywords = (values) => {
    let data = {
      keywords: Array.isArray(values?.keywords) ? values.keywords : [],
      websiteToken: keywordToken
    }
    dispatch(saveAiKeywords(data, usertoken));
  };

  const onClickRow = (data) => {
    if (userData?.role === "superadmin" || userData?.role === "admin") {
      setRecord(data);
      form.setFieldsValue({
        brandDomain: data?.brandDomain,
        brandName: data?.brandname,
      });
      showModal(true);
    }
  };

  const onClickRowAlertKeywords = (data) => {
    if (userData?.role === "superadmin" || userData?.role === "admin") {
      dispatch(getAiKeywords(data, usertoken));
      setKeywordToken(data);
      setAiModal(true);
    }
  };

  const onStatusChange = (data) => {
    const newdata = {
      admin_id: userData?._id,
      brand_id: data?._id,
      isActive: !data?.isActive,
    };
    dispatch(Brand_Status(newdata, usertoken, afterAdded));
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCancelAiKeywords = () => {
    setAiModal(false);
  };

  const adminsColumns = [
    {
      title: "Sr #",
      dataIndex: "serial",
    },
    {
      title: "Brand Name",
      dataIndex: "brandname",
    },
    {
      title: "Brand Domain",
      dataIndex: "brandDomain",
    },
    // {
    //   title: "Token",
    //   dataIndex: "token",
    //   render: (source) => (
    //     <span style={{ fontSize: '12px' }}>
    //       {source}
    //       <Button style={{ marginLeft: 10 }} icon={<CopyOutlined />} onClick={() => handleCopy(source)} />
    //     </span>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "isActive"
    },
    {
      title: "Edit",
      dataIndex: "token",
      render: (source, item) => (
        <span style={{ fontSize: '12px' }}>
          <Button style={{ marginLeft: 10 }} icon={<EditOutlined />} onClick={() => onClickRow(item)} />
        </span>
      ),
    },

    {
      title: "Alert Keywords",
      dataIndex: "token",
      render: (source, item) => (
        <span style={{ fontSize: '12px' }}>
          <Button style={{ marginLeft: 10 }} icon={<EditOutlined />} onClick={() => onClickRowAlertKeywords(source)} />
        </span>
      ),
    },
  ];

  const columns = [
    {
      title: "Sr #",
      dataIndex: "serial",
    },
    {
      title: "Brand Name",
      dataIndex: "brandname",
    },
    {
      title: "Brand Domain",
      dataIndex: "brandDomain",
    },
    // {
    //   title: "Token",
    //   dataIndex: "token",
    //   render: (source) => (
    //     <span style={{ fontSize: '12px' }}>
    //       {source}
    //       <Button style={{ marginLeft: 10 }} icon={<CopyOutlined />} onClick={() => handleCopy(source)} />
    //     </span>
    //   ),
    // }
  ];

  const data = [];

  for (let i = 0; i < allData?.length; i++) {
    data.push({
      key: i,
      serial: i + 1,
      _id: allData[i]?._id,
      brandname: allData[i]?.brandname,
      token: allData[i]?.token,
      brandDomain: allData[i]?.brandDomain,
      isActive: <Switch checked={allData[i]?.isActive} onClick={(e) => e.stopPropagation()} // stop row click
        onChange={() => onStatusChange(allData[i])} />,
    });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <div>
        </div>
        <div style={{ marginBottom: userData?.role === "superadmin" || userData?.role === "admin" ? '15px' : '0px' }}>
          {userData?.role === "superadmin" || userData?.role === "admin" ?
            <Button type="primary" onClick={() => showModal(false)}>
              Add Brand
            </Button>
            : null
          }
        </div>

        {/* Modal Start */}
        <Modal
          title={isEdit ? "Edit Brand" : "Add Brand"}
          open={open}
          onCancel={handleCancel}
          maskClosable={false}
          footer={null}>
          <Form
            form={form}
            layout="vertical"
            name="basic"
            initialValues={{
              remember: true
            }}
            onFinish={onFinish}
            autoComplete="off">
            <Form.Item
              label="Brand Name :"
              name="brandName"
              rules={[
                {
                  required: true,
                  message: "Please input brand name!"
                }
              ]}>
              <Input placeholder="Brand Name" />
            </Form.Item>

            <Form.Item
              label="Brand Domain :"
              name="brandDomain"
              rules={[
                {
                  required: true,
                  message: "Please input brand domain!"
                }
              ]}>
              <Input placeholder="eg:xyz.com" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isAddLoading}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        {/* Modal End */}
        {/* Modal Ai Keywords */}
        <Modal
          title={"AI Alert Keywords"}
          open={aiModal}
          onCancel={handleCancelAiKeywords}
          maskClosable={false}
          footer={null}>
          {isLoadingAiKeywords ? <Spin size="small" /> :
            <Form
              form={form}
              layout="vertical"
              name="basic"
              initialValues={{
                keywords: AiKeywordsdata?.keywords,
              }}
              onFinish={onFinishAiKeywords}
              autoComplete="off">
              <Form.Item
                label="Keywords :"
                name="keywords"
              >
                <Select
                  mode="tags"
                  loading={isLoadingAiKeywords}
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Type and press Enter to add. Eg: Discount, Offer, Refund (optional — leave empty to clear)"
                  tokenSeparators={[',']}
                />
              </Form.Item>
              <Form.Item>
                <Button disabled={isLoadingSaveAiKeywords} type="primary" htmlType="submit" loading={isLoadingSaveAiKeywords}>
                  Submit
                </Button>
              </Form.Item>
            </Form>}

        </Modal>
        {/* Modal Ai Keywords End */}
      </div>
      <Table
        loading={isLoading}
        columns={userData?.role === "admin" ? adminsColumns : columns}
        dataSource={data}
        onRow={(record) => ({
          onClick: (event) => {
            // Prevent if clicked on a button or switch
            if (
              event.target.closest('button') ||
              event.target.closest('.ant-switch') // switch has this class
            ) {
              return;
            }
            if (record?._id) {
              navigate(`/brands/${record.token}`);
            }
          }
        })}
        pagination={false}
      />
    </div>
  );
};

export default Brands;
